import React from 'react';

const SuggestionButton = ({children, onClick}) => {
  return (
    <button
      onClick={onClick}
      className="w-full px-4 py-3 text-left bg-gray-50 hover:bg-gray-100 
                     border border-gray-200 rounded-lg transition-colors duration-200">
      <span className="flex items-center gap-2">
        <svg className="w-5 h-5 text-primary" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
          />
        </svg>
        {children}
      </span>
    </button>
  );
};

export default SuggestionButton;
